import { Box, Drawer, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { InfoDrawerBtn } from "./InfoDrawerBtn";
import { ReviewDrawerBtn } from "./ReviewDrawerBtn";
import { LocationDrawerBtn } from "./LocationDrawerBtn";
import { PhotoDrawerBtn } from "./PhotoDrawerBtn";

export function TabSection({
  sectionRef,
}: {
  sectionRef: React.MutableRefObject<HTMLDivElement | null | undefined>;
}) {
  const [isSticky, setIsSticky] = useState(false);

  const handleClick = () => {
    if (sectionRef.current) {
      window.scrollBy({
        behavior: "smooth",
        top: sectionRef.current?.offsetTop - window.scrollY - 80,
      });
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const stickyBox = document.getElementById("sticky-box");
      if (stickyBox) {
        const stickyPosition = stickyBox.getBoundingClientRect().top;
        setIsSticky(stickyPosition <= 0);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Box
      id="sticky-box"
      display="flex"
      flex={1}
      alignItems="center"
      justifyContent="center"
      width="100%"
      py={2}
      px="12%"
      zIndex={5}
      bgcolor={isSticky ? "white" : "#F0F0F4"}
      boxShadow={isSticky ? 2 : 0}
      position="sticky"
      top={0}
    >
      <Box width="1000px" display="flex">
        <Box
          display="flex"
          flex={1}
          alignItems="center"
          justifyContent="center"
          borderRight={1}
          borderColor="divider"
          p={2}
          sx={{
            cursor: "pointer",
            "&:hover": {
              opacity: "0.6",
            },
          }}
          onClick={handleClick}
        >
          <Typography>プラン・予約</Typography>
        </Box>
        <InfoDrawerBtn />

        <ReviewDrawerBtn />

        <LocationDrawerBtn />

        <PhotoDrawerBtn />
      </Box>
    </Box>
  );
}
